// frontend/src/components/notes/constants.js
// Shared constants for Notes system to ensure consistency

export const INITIAL_NOTE = {
  _id: 'new',
  title: '',
  content: '',
  type: 'text'
};

export const NOTE_DEFAULTS = {
  format: 'markdown',
  status: 'active',
  category: 'General'
};

export const NOTE_TYPES = {
  TEXT: 'text',
  VOICE: 'voice'
};

// UI Constants
export const SIDEBAR_WIDTH = 320;
export const ROW_HEIGHT = 48; // Compact mode only
export const SEARCH_DEBOUNCE_MS = 150;